var StorewaitBoardItemView = Backbone.Epoxy.View.extend({
  template: 'store-wait-board.storeWaitBoardItem',

  initialize: function() {
    this.hasRendered = false;

    this.render();
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.applyBindings();
  },

  cleanup: function() {
    this.removeBindings();
  }

});

module.exports = StorewaitBoardItemView;
